import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card, Spinner, Button } from 'react-bootstrap';
import { getUser, getStore } from '../../actions/userActions';
import { logout } from '../../actions/authActions';

import AdminSidebar from './AdminComponent/AdminSidebar';
import Header from './AdminComponent/Header';
import Footer from './AdminComponent/Footer';
import DemoStats from './AdminComponent/DemoStats';
import UpdateOzimoCard from './AdminComponent/UpdateOzimoCard';
import UpdateAsplCard from './AdminComponent/UpdateAsplCard';

import StoreInfoPanel from '../../components/StoreInfoPanel/StoreInfoPanel';
import CreadStoreForm from '../../components/CreadStoreForm/CreadStoreForm';


const Dashboard = () => {
  const dispatch = useDispatch();
  const { token } = useSelector(state => state.authReducer);
  const { user, store, isLoading } = useSelector(state => state.userReducer);

  const [dataFetched, setDataFetched] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (token && !dataFetched) {
      try {
        const parsed = JSON.parse(token);
        if (parsed?.id) {
          dispatch(getUser(parsed.id));
          dispatch(getStore(parsed.id));
          setDataFetched(true);
        }
      } catch (err) {
        console.error("Token error:", err);
      }
    }
  }, [dispatch, token, dataFetched]);

  const storeCreated = store && store.length !== 0;

  const handleLogout = () => {
    dispatch(logout());
    window.location.replace('/');
  };

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <AdminSidebar collapsed={collapsed} toggleSidebar={() => setCollapsed(!collapsed)} />
      <div style={{ marginLeft: collapsed ? '60px' : '200px', width: '100%', transition: 'margin-left 0.3s' }}>
        <Header />

        <Container fluid>
          <Row className="mb-4">
            <Col md={4}><DemoStats /></Col>
            <Col md={4}><UpdateOzimoCard /></Col>
            <Col md={4}><UpdateAsplCard /></Col>
          </Row>

          <Row className="mb-4">
            <Col md={6}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title>User Info</Card.Title>
                  <ul>
                    <li>Username: {user?.username || '...'}</li>
                    <li>Email: {isLoading ? <Spinner size="sm" /> : user?.email}</li>
                    <li>Phone: {isLoading ? <Spinner size="sm" /> : user?.phone}</li>
                    <li>Address: {isLoading ? <Spinner size="sm" /> : user?.address}</li>
                  </ul>
                  <Button variant="danger" onClick={handleLogout}>Logout</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title>{storeCreated ? "Store Info" : "Create Store"}</Card.Title>
                  {storeCreated ? (
                    <StoreInfoPanel store={store} loading={isLoading} />
                  ) : showForm ? (
                    <CreadStoreForm />
                  ) : (
                    <Button onClick={() => setShowForm(true)}>Create Store</Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        <Footer />
      </div>
    </div>
  );
};

export default Dashboard;
